<header>
    <div class="header-container">
        <!-- Mobile Toggle Button -->
            <button *ngIf="isMobile && !showCloseIcon " (click)="toggleSideNav($event)" class="side-nav-toggle">
                ☰
            </button>
            <button *ngIf="isMobile && showCloseIcon " style="align-self: flex-start;"  (click)="toggleSideNav($event)" class="side-nav-toggle">
                <span aria-hidden="true" >&times;</span>
            </button>

        <!-- Brand Logo -->
        <span class="brand-logo" >
            <img *ngIf="isMobile" style="width:115px;height: 50px;" src="../../../assets/stell-logo-white.svg" alt="Stellantis-logo" />
            <img *ngIf="!isMobile" src="../../../assets/stell-logo-white.svg" alt="Stellantis-logo" />
        </span>
        <span *ngIf="!isMobile" style="flex: 1;margin-left: 20px;">
            <img style="width:115px;height: 50px;" src="../../../assets/AVIR_LOGO_2.jpg" alt="Stellantis-logo" />
        </span>

        <!-- <button   (click)="generate()" >
           Generate
        </button> -->

        <!-- User Icon (Dropdown) -->
        <div class="user-icon" style="flex:1; justify-content: flex-end;">
           <span> {{driverName}} &nbsp;</span> <mat-icon (click)="logout()">logout</mat-icon><span (click)="logout()" style="font-size:x-small">&nbsp; Logout </span> 
        </div>
    </div>
</header>